import React from 'react'

import { GameId, ProductV2, StoreOfferProduct } from '@common'
import cx from 'classnames'
import Image from 'next/image'

import { ClashOfClansContainer } from '@/features/storefronts/_storeBase/card/v2/OfferCard/games/clashofclans/components/ClashOfClansContainer'
import { Ribbon, Ribbons } from '@/features/storefronts/_storeBase/card/v2/OfferCard/shared/Ribbons'
import { Countdown, ValueBadge } from '@/features/storefronts/_storeBase/card/v2/shared'
import { getHeroFallbackImage } from '@/features/storefronts/_storeBase/card/v2/shared/RegularHero'
import { Flare } from '@/features/storefronts/_storeBase/flare/Flare'
import { isStoreSpecial } from '@/features/storefronts/productFilters'
import { resolveProductImage } from '@/utils/resolveProductImage'

import styles from './PdpProductHero.module.scss'

interface Props {
  product: ProductV2
  ribbons: Ribbon[]
  className?: string
  enableNewVisuals?: GameId[]
}

const PdPHero = ({ product, className }: { product: ProductV2; className?: string }) => {
  const heroImage = product.images.at(0) ?? getHeroFallbackImage(product.game)
  const isStoreSpecialOffer = isStoreSpecial(product)
  if (!heroImage) {
    return null
  }
  return (
    <div className={cx(styles[product.game], className)}>
      <Image
        src={heroImage}
        alt="Hero image"
        width={343}
        height={184}
        style={isStoreSpecialOffer ? {} : { padding: '16px' }}
        objectFit={'contain'}
      />
    </div>
  )
}

const SelectRenderedProductHero = (product: ProductV2) => {
  const isPass = !!product.contentCounts.SEASON_PASS
  const isEventPass = isPass && product.type === 'offer'

  if (isPass) {
    return (
      <div className={styles.PassHero}>
        <Flare game={'clashofclans'} blurryEllipsis={false} />
        <div
          className={cx(styles.ProductImageContainer, {
            [styles.EventPass]: isEventPass,
          })}
        >
          <div className={styles.ProductImage}>
            <Image
              className={styles.PassImage}
              src={resolveProductImage(product)}
              objectFit={'contain'}
              fill
              sizes={'360px'}
              quality={100}
              alt="passcard-background"
              placeholder="empty"
            />
          </div>
        </div>
      </div>
    )
  }
  return <PdPHero product={product} className={styles.ClashHero} />
}

export const ClashPdpProductHero = ({ product, ribbons, className }: Props) => {
  const isMultiItemOffer = product.contents.length > 1
  return (
    <ClashOfClansContainer
      product={product}
      className={cx(styles.ContainerStyle, className, {
        [styles.MultiItemContainer]: isMultiItemOffer,
        [styles.SingleItemContainer]: !isMultiItemOffer,
      })}
      type={'pdp'}
    >
      <Countdown product={product as StoreOfferProduct} />
      <Flare game={'clashofclans'} blurryEllipsis={false} />
      {SelectRenderedProductHero(product)}
      {ribbons.length === 0 ? <ValueBadge product={product as StoreOfferProduct} /> : <Ribbons ribbons={ribbons} />}
    </ClashOfClansContainer>
  )
}
